<template>
  <div class="animated fadeIn">
      <NotesForm data_type="sample" />
  </div>
</template>

<script>
import NotesForm from '@/components/shared/form/NotesForm.vue';

export default {
    name: "SampleNote",
    components: { 
      NotesForm 
    },
}
</script>